import { render, staticRenderFns } from "./StripeElements.vue?vue&type=template&id=5ff89be8&scoped=true"
import script from "./StripeElements.vue?vue&type=script&lang=js"
export * from "./StripeElements.vue?vue&type=script&lang=js"
import style0 from "./StripeElements.vue?vue&type=style&index=0&id=5ff89be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff89be8",
  null
  
)

export default component.exports